<template>
  <div id="app" v-if="visible">
    <div class="background"></div>
    <SubscriptionPopUp :orderData="orderData" @close="close"/>
  </div>
</template>

<script>
  import SubscriptionPopUp from './components/SubscriptionPopUp';
  export default {
  name: 'app',
    components: {
      SubscriptionPopUp,
    },

    data () {
      return {
        visible: false,
        orderData: {
          "filters": {
            "basic": [],
            "month": [],
            "msp": [],
            "phone": [],
            "legal_form": 0
          },

          cost: 0,
          cost_one_company_text: 0,
          period: "",
          subscription_start: "",

          deposit_refill: false,

          user_id: null,
          user_email: null,
          balance: null,
        },
      }
  },

  methods: {
      open() {
          this.visible = true;
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
      },
      close() {
          this.visible = false;
      },
      setOrderData(data) {
          this.orderData = data;
      }
  }
}
</script>

<style>
  #app {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .background {
    position: fixed;
    z-index: 300;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    opacity: 0.5;
    background-color: black;
  }
</style>
